import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexRow,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { ProductPriceCart } from './ProductPriceCart';
import { Input } from '../General/Input';
import { ProductPriceCartMobile } from './ProductPriceCartMobile';
import { StockInfo } from './StockInfo';
import { getProductDefaultInfo } from '../../../utilities/selectors';
import { getZemplinProductDefaultInfo } from '../selectors';

export interface Props {
  product: any;
  addToRequest: any;
  addToCart: any;
  isLoggedIn: boolean;
}

function ProductTabRowMobile({
  product,
  addToCart,
  addToRequest,
  isLoggedIn,
}: Props) {
  const { picture, url, name, ordernr } = getProductDefaultInfo(product);
  const {
    unit,
    onStock,
    price,
    priceWithoutVat,
    storesInfo,
  } = getZemplinProductDefaultInfo(product);
  const correctPrice = isLoggedIn ? priceWithoutVat : price;

  return (
    <Wrapper>
      <LeftWrapper>
        <ImageNameWrapper>
          <ImageWrapper to={url}>
            <Image alt={`Obrázok ku produktu ${name}`} src={picture} />
          </ImageWrapper>
          <NameInputWrapper>
            <Link to={url}>
              <Name>{name}</Name>
            </Link>
            <OrderNr>{ordernr}</OrderNr>
          </NameInputWrapper>
        </ImageNameWrapper>
        <StockInfo
          storesInfo={storesInfo}
          withoutExactStockCount={false}
          bottomMargin={false}
          onStock={onStock}
          unit={unit}
        />
      </LeftWrapper>
      <ProductPriceCartMobile
        price={correctPrice}
        unit={unit}
        addToRequest={addToRequest}
        addToCart={addToCart}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  margin: 0;
  padding: ${rem(24)} 0;
  border-radius: ${rem(2)};
  border-top: ${({ theme }) => theme.borders.primary};
  background-color: ${({ theme }) => theme.colors.white};
  justify-content: space-between;
  align-items: stretch;

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }

  ${({ theme }) => theme.mediab.l925`
    max-width: initial;
  `}

  ${({ theme }) => theme.mediab.m760`
    margin: 0 auto;
    max-width: initial;
    width: 100%;
    &:last-child {
      margin: 0 auto;
    }
  `}
`;

const OrderNr = styled(TextP)`
  color: ${({ theme }) => theme.colors.placeholder};
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
`;

const ImageNameWrapper = styled(FlexRow)`
  margin-bottom: ${rem(8)};
`;

const LeftWrapper = styled(FlexCol)`
  justify-content: space-between;
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(16)};
`;

const Image = styled.img`
  width: ${rem(32)};
  height: ${rem(32)};
  max-width: initial;
`;

const NameInputWrapper = styled(FlexCol)`
  margin-right: ${rem(32)};

  ${({ theme }) => theme.mediab.s450`
     margin-right: ${rem(0)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(12)};
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;
  width: ${rem(250)};
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 300;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  max-width: ${rem(210)};

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${rem(8)};
  `}

  ${({ theme }) => theme.mediab.s450`
     max-width: ${rem(130)};
  `}
`;

export { ProductTabRowMobile };
